import request from './base'

export const getTaskList = (params) => {
    return request.post("/merchant/v1/task/list", params)
}
export const getTaskInfo = (params) => {
    return request.post("/merchant/v1/task/info", params)
}
export const taskPlan = (params) => {
    return request.post("/merchant/v1/task/plan", params)
}
export const taskAdd = (params) => {
    return request.post("/merchant/v1/task/add", params)
}
export const taskCancel = (params) => {
    return request.post("/merchant/v1/task/cancel", params)
}
export const taskDownloadExcel = (params) => {
    return request.download("/merchant/v1/task/exportExcel", params)
}
export const taskBoard = (params) => {
    return request.post("/merchant/v1/task/board", params)
}


// WEBPACK FOOTER //
// ./src/api/task.js